<h4 class="title">Screen Access</h4>
<div class="row" style="padding: 0px 0px 23px 10px;">

    <!--        
            <div class="col-md-12 mt-20">
                <button type="button" class="btn btn-primary">Add</button>
             </div> -->

</div>

<div class="row">
    <!-- <div class="col-md-4">
            <div class="search-hero">
                <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                    [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
            </div>
        </div> -->
    <div class="col-md-5">
        <h5 class="form-lable">Level:</h5>
        <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Screen:</h5>
        <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-2 text-right">
        <button type="button" class="btn btn-primary mr-0" style="margin-top: 25px;">Search</button>
    </div>
</div>
<br>
<div class="row">
    <!-- <div class="col-md-4">
            <div class="search-hero">
                <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                    [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
            </div>
        </div> -->
    <div class="col-md-6">
        <h5 class="form-lable">Level: <span>60-COLLECTOR-PROCESSOR</span></h5>

    </div>
    <div class="col-md-6">
        <h5 class="form-lable" style="text-align: right;">Screen:<span>STAT CARD LOAN</span></h5>

    </div>
    <div class="col-md-12">
        <div class="doc-table">
            <table class="det-t">
                <tr class="thhead th-b">
                    <th class="th-1">
                        Fields
                    </th>
                    <th class="th-1">
                        <input type="checkbox">
                    </th>
                </tr>
                <tr class="thhead th-b">
                    <th colspan="2" class="th-1" style="text-align: center;">
                        LOAN DETAILS
                    </th>
                </tr>
                <tr class="tdrow">
                    <td>Loan Number</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Customer ID</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Note Date</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Asset Cost</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Account Status</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Sourcing Dealer</td>
                    <td><input type="checkbox"></td>
                </tr>
    
                <tr class="tdrow">
                    <td>Disbursing Dealer</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Unit Code</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>LTV</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Principal Outstanding</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>No. of Installments</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Scheme</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Collectibility Parameter</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Delinquency Reason</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>No. of Installments Overdue</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Principal Overdue</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Interest Overdue</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Total Payment Overdue</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Current DPD</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Cycle String</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Charge off Flag</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Charge offf Date</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Installment Mode</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Total Amount Due</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Overlimit Amount</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Total Current Due</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Bucket1/Cycle1</td>
                    <td><input type="checkbox"></td>
                </tr>
            </table>
        </div>
    </div>
    <br>
</div>


<!-- <div class="doc-table">
      <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
          [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
          <ng-template pTemplate="header">
      <tr style="text-align: center;">
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Address Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Bank Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Income Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Liability Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Esisting Asset Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Credit Card Details</button> </td>
      </tr>
          </ng-template>
       </p-table>  </div>
    </div> -->